<script>
  import { v4 as uuidv4 } from "uuid";
  import { onMount } from "svelte";
  import { gsap } from "gsap";
  import Title from "./Title.svelte";

  export let full = false;
  export let light = false;
  export let dark = false;

  const componentId = "lateral__" + uuidv4();

  onMount(() => {
    gsap.from("#" + componentId + " .lateral__text--left", {
      opacity: 0,
      xPercent: -10,
      ease: "power",
      delay: 0.5,
      scrollTrigger: {
        trigger: "#" + componentId,
        toggleActions: "play complete reverse reset",
        start: "top 80%",
        duration: 0.2,
      },
    });

    gsap.from("#" + componentId + " .lateral__text--right", {
      opacity: 0,
      xPercent: 10,
      ease: "power",
      delay: 0.75,
      scrollTrigger: {
        trigger: "#" + componentId,
        toggleActions: "play complete reverse reset",
        start: "top 80%",
        duration: 0.2,
      },
    });

    gsap.from("#" + componentId + " .lateral__styled-text", {
      opacity: 0,
      yPercent: 100,
      ease: "power",
      delay: 1,
      scrollTrigger: {
        trigger: "#" + componentId,
        toggleActions: "play complete reverse reset",
        start: "top 80%",
        duration: 0.2,
      },
    });
  });
</script>

<div class="lateral {$$props.class}" id={componentId}>
  <Title title={"Lateral CS"} {dark} />
  <div class:lateral__text-container--full={full}>
    <div
      class="lateral__text lateral__text--left"
      class:lateral__text--light={light}
      class:lateral__text--dark={dark}
      class:lateral__text--full={full}
    >
      Les impacts au sol au tennis sont tels, qu’Artengo et Decathlon Sport Lab
      ont développé ce concept exclusif.
    </div>
    <div
      class="lateral__text lateral__text--right"
      class:lateral__text--light={light}
      class:lateral__text--dark={dark}
      class:lateral__text--full={full}
    >
      Constitué de PU (Polyuréthane) inséré sous le talon au niveau des zones
      d’appuis, il réduit de 13% la force d’impact au sol.
    </div>
  </div>
  <div class="lateral__styled-text">
    Engagez vous sans risque dans vos frappes !
  </div>
</div>

<style lang="scss">
  $black: #131111;
  $white: #ffffff;

  .lateral {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;

    &__text {
      font-family: "Roboto", sans-serif;
      padding: 0 1rem 0 1rem;
      text-align: center;

      &-container--full {
        display: flex;
        width: 100%;
      }

      &--left {
        color: $black;
        margin-left: 25%;
        text-align: right;
      }

      &--right {
        color: $white;
        margin-right: 25%;
        text-align: left;
        padding-bottom: 2rem;
      }

      &--full {
        width: 50%;
      }

      &--light {
        color: $black;
        margin: 0;
        text-align: center;
      }

      &--dark {
        color: $white;
        margin: 0;
        text-align: center;
      }
    }

    &__styled-text {
      color: $white;
      background-color: $black;
      font-family: "DecathlonBeta", sans-serif;
      padding: 1rem 2rem;
      text-align: center;
      text-transform: uppercase;
    }
  }
</style>
